import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FC } from "react";
import appTranslationsHelper from "../../../../../languages/app-translations.helper";
import TableButtonComponent, {
  TableButtonProps,
} from "../table-button.component";

type TableDeleteButtonProps = Pick<
  TableButtonProps,
  "onClick" | "title" | "isDisabled" | "isLoading" | "idForTesting"
>;

const TableDeleteButtonComponent: FC<TableDeleteButtonProps> = (props) => {
  const tableTranslations =
    appTranslationsHelper.getComponentTranslations().table;

  return (
    <TableButtonComponent
      onClick={props.onClick}
      icon={faTrash}
      type="danger"
      title={props.title ?? tableTranslations.deleteButtonTitle}
      isDisabled={props.isDisabled}
      isLoading={props.isLoading}
      idForTesting={props.idForTesting}
    />
  );
};

export default TableDeleteButtonComponent;
